export default {
  formId: 'checkoutForm',
  formField: {
    firstName: {
      name: 'firstName',
      label: 'checkout.form.fullName.label',
      requiredErrorMsg: 'checkout.form.fullName.required'
    },
    lastName: {
      name: 'lastName',
      label: 'checkout.form.lastName.label',
      requiredErrorMsg: 'checkout.form.lastName.required'
    },
    address1: {
      name: 'address2',
      label: 'checkout.form.address.label',
      requiredErrorMsg: 'checkout.form.address.required'
    },

    city: {
      name: 'city',
      label: 'checkout.form.city.label',
      requiredErrorMsg: 'checkout.form.city.required'
    },
    state: {
      name: 'state',
      label: 'checkout.form.state.label',
      requiredErrorMsg: 'checkout.form.state.required'
    },
    zipcode: {
      name: 'zipcode',
      label: 'checkout.form.document.label',
      requiredErrorMsg: 'checkout.form.document.required',
      invalidErrorMsg: 'checkout.form.document.invalid'
    },
    country: {
      name: 'country',
      label: 'checkout.form.country.label',
      requiredErrorMsg: 'checkout.form.country.required'
    },
    useAddressForPaymentDetails: {
      name: 'useAddressForPaymentDetails',
      label: 'checkout.form.useAddressForPaymentDetails.label'
    },
    nameOnCard: {
      name: 'nameOnCard',
      label: 'checkout.form.nameOnCard.label',
      requiredErrorMsg: 'checkout.form.nameOnCard.required'
    },
    cardNumber: {
      name: 'cardNumber',
      label: 'checkout.form.cardNumber.label',
      requiredErrorMsg: 'checkout.form.cardNumber.required',
      invalidErrorMsg: 'checkout.form.cardNumber.invalid'
    },
    expiryDate: {
      name: 'expiryDate',
      label: 'checkout.form.expiryDate.label',
      requiredErrorMsg: 'checkout.form.expiryDate.required',
      invalidErrorMsg: 'checkout.form.expiryDate.invalid'
    },
    cvv: {
      name: 'cvv',
      label: 'checkout.form.cvv.label',
      requiredErrorMsg: 'checkout.form.cvv.required',
      invalidErrorMsg: 'checkout.form.cvv.invalid'
    }
  }
};
